module.exports = __webpack_public_path__ + "static/img/Top1.7c2b26b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-go/mobile/Top1.png
// module id = Xi+c
// module chunks = 12